(() => {
  class PasswordProtect extends HTMLElement {
    constructor() {
      super();
      this.sectionHTML = this.closest(".shopify-section").outerHTML;

      this.form = this.querySelector("form");
      this.errorFalse = this.querySelector("[data-error-false]");
      this.errorBurned = this.querySelector("[data-error-burned]");

      this.form?.addEventListener("submit", this.onSubmit.bind(this));

      this.sectionId = this.getAttribute("data-customize");

      this.init();
    }

    disconnectedCallback() {
      document.body.insertAdjacentHTML("afterbegin", this.sectionHTML);
    }

    init() {
      if (!this.sectionId) {
        document.body.classList.add("body-locked");
        this.watchMutations();
        document.body.insertAdjacentHTML(
          "beforeend",
          `
          <style>
            .promo_topbar,
            #shopify-section-footer,
            #shopify-section-header {
              pointer-events: none !important;
            }
          </style>
        `
        );
        this.closest(".shopify-section").style.pointerEvents =
          "auto !important";
      }
      if (this.sectionId) {
        window.addEventListener("shopify:section:select", (event) => {
          const sectionId = event.detail.sectionId;
          if (sectionId === this.sectionId) {
            this.style.display = "";
          } else {
            this.style.display = "none";
          }
        });
        window.addEventListener("shopify:section:deselect", (event) => {
          const sectionId = event.detail.sectionId;
          if (sectionId === this.sectionId) {
            this.style.display = "none";
          }
        });
      }

      $("[data-slider]").slick({
        dots: true,
        slidesToShow: 1,
        infinite: false,
        arrow: false,
      });
    }

    update() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {}, 10);
    }

    watchMutations() {
      this.mutationObserver = new MutationObserver(() => {
        this.mutationObserver.disconnect();
        this.remove();
      });

      this.mutationObserver.observe(this, {
        attributes: true,
      });
    }

    async onSubmit() {
      const code = this.form.code.value.trim();

      const isActive = await this.checkCode(code);
      console.log(isActive);
      if (isActive === false) {
        this.errorFalse?.classList.remove("d-none");
        return;
      } else if (isActive === "BURNED") {
        this.errorBurned?.classList.remove("d-none");
        return;
      }

      await this.setCodeInCartAttribute(code);

      window.location.href = window.Shopify.routes.root;
    }

    async checkCode(code) {
      this.errorFalse?.classList.add("d-none");
      this.errorBurned?.classList.add("d-none");

      const response = await fetch(
        `${window.Shopify.routes.root}a/check-code?code=${code}`
      );
      const { isActive } = await response.json();

      return isActive;
    }

    async setCodeInCartAttribute(CODE) {
      await fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ attributes: { CODE } }),
      });
    }
  }

  if (!customElements.get("password-protect")) {
    customElements.define("password-protect", PasswordProtect);
  }
})();
